import { mountApp } from '@/apps/mount_app';
import FeaturedHackathons from '@/components/devpost_homepage/FeaturedHackathons.vue'

export default () => {
  mountApp({
    domId: "featured-hackathons-wrapper",
    component: FeaturedHackathons
  })
}
